module.exports = __webpack_public_path__ + "img/error404.7987da46.svg";